import React, { useEffect, useState, useRef } from "react";
import {useNavigate} from 'react-router-dom';

import MenuAlto from './menuAlto'
import Intestazione from './intestazione'
import TitoloPagina from './TitoloPagina'
import FondoPagina from './fondoPagina'
import FormResponsive from './FormResponsive'
import Parametri from './parametri';
import Clessidra from './Clessidra';
import FormattaImportoVideo from './FormattaImportoVideo';

import './App.css';

function Acquista(props) {
    var giorni=[];
    for (var g=1; g<=31; g++) giorni.push(g);
    const mesi=["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];

    const comandoNavigazione = useNavigate();

    const [flagAttesa, setFlagAttesa] = useState(true);
    const [flagRegistrato, setFlagRegistrato] = useState(false);
    const [flagEvidenziaRichiestaConsenso, setFlagEvidenziaRichiestaConsenso] = useState(false);
    const [sessionId, setSessionId] = useState("");
    const [giornoChiusuraEsercizio, setGiornoChiusuraEsercizio] = useState(31);
    const [meseChiusuraEsercizio, setMeseChiusuraEsercizio] = useState(11); // mesi da 0 a 11 attenzione!
    const [flagConsenso, setFlagConsenso] = useState(false);
    const [valoriCampiObbligatoriForm, setValoriCampiObbligatoriForm] = useState({});
    const [valoriCampiFacoltativiForm, setValoriCampiFacoltativiForm] = useState({});
    const [listino, setListino] = useState([]);
    const [pacchettoSelezionato, setPacchettoSelezionato] = useState("");
    const [pacchettiAggiuntivi, setPacchettiAggiuntivi] = useState("");

    const elencoCampiObbligatori = [
        { label: 'Indirizzo Email:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Tuo cognome:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Tuo nome:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Nome società:', type: 'text', initialWidth: 250, minWidth: 250 },
        { label: 'P.IVA società:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Codice fiscale società:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Indirizzo società:', type: 'text', initialWidth: 350, minWidth: 350 },
        { label: 'CAP società:', type: 'text', initialWidth: 50, minWidth: 50 },
        { label: 'Città società:', type: 'text', initialWidth: 150, minWidth: 150 },
    ];

    const elencoCampiFacoltativi = [
        { label: 'Codice Destinatario per ricevere Fattura Elettronica:', type: 'text', initialWidth: 150, minWidth: 150 },
        { label: 'Telefono:', type: 'text', initialWidth: 150, minWidth: 150 },
    ];

    useEffect(() => {
        setSessionId("");
        setFlagConsenso(false);
        setValoriCampiObbligatoriForm({});
        setValoriCampiFacoltativiForm({});
        preflight();
    },[])

    function vaiLink(link) {
        comandoNavigazione(link);
        window.scrollTo(0, 0);
    }    

    function verificaEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
        return emailRegex.test(email);
    }

    function preflight() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"preflight", "listino":1})
        };

        fetch(Parametri("serverURL"), requestOptions).then(risposta => risposta.json()).then(
            (valoreDiRitorno) => {
                setFlagAttesa(false);
                if (valoreDiRitorno.risultatoOperazione!==1) {
                    alert("Si è verificato un errore gestendo la richiesta, per favore riprova e se l'errore persiste contattaci all'indirizzo "+props.emailAssistenza);
                    vaiLink("/")
                } else {
                    setListino(valoreDiRitorno.listino);
                    setPacchettoSelezionato(valoreDiRitorno.listino[0].CODICE_ARTICOLO);
                    setSessionId(valoreDiRitorno.sessionId);
                }
            },
            (error) => {
                setFlagAttesa(false);
                alert("Si è verificato un errore gestendo la richiesta, per favore riprova e se l'errore persiste contattaci all'indirizzo "+props.emailAssistenza);
                vaiLink("/")
            }
        ) 
    }    

    function inviaDati() {
        if (!flagConsenso) {
            setFlagEvidenziaRichiestaConsenso(true);
            alert("Spunta il consenso al trattamento dati per proseguire, senza quello non possiamo memorizzare i dati che hai inserito");
            return;
        }

        if (valoriCampiObbligatoriForm.input_0=="" || !verificaEmail(valoriCampiObbligatoriForm.input_0)) {
            alert("Verifica l'indirizzo email");
            return;
        }
        if (valoriCampiObbligatoriForm.input_1===undefined || valoriCampiObbligatoriForm.input_1=="") {
            alert("Inserisci il cognome");
            return;
        }
        if (valoriCampiObbligatoriForm.input_2===undefined || valoriCampiObbligatoriForm.input_2=="") {
            alert("Inserisci il nome");
            return;
        }
        if (valoriCampiObbligatoriForm.input_3===undefined || valoriCampiObbligatoriForm.input_3=="") {
            alert("Inserisci il nome della società");
            return;
        }
        if ((valoriCampiObbligatoriForm.input_4===undefined || valoriCampiObbligatoriForm.input_4=="") && (valoriCampiObbligatoriForm.input_5===undefined || valoriCampiObbligatoriForm.input_5=="")) {
            alert("Inserisci la Partita IVA o il Codice Fiscale della società");
            return;
        }
        if (valoriCampiObbligatoriForm.input_6===undefined || valoriCampiObbligatoriForm.input_6=="") {
            alert("Inserisci l'indirizzo della società");
            return;
        }
        if (valoriCampiObbligatoriForm.input_7===undefined || valoriCampiObbligatoriForm.input_7=="") {
            alert("Inserisci il CAP della società");
            return;
        }
        if (valoriCampiObbligatoriForm.input_8===undefined || valoriCampiObbligatoriForm.input_8=="") {
            alert("Inserisci la città della società");
            return;
        }
        
        setFlagAttesa(true);

        var p = pacchettoSelezionato;
        if (pacchettiAggiuntivi != "") p = p + ";" + pacchettiAggiuntivi;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"acquista",
                sessionId:sessionId,
                consenso: flagConsenso?1:0,
                email:valoriCampiObbligatoriForm.input_0,
                cognome:valoriCampiObbligatoriForm.input_1,
                nome:valoriCampiObbligatoriForm.input_2,
                societa:valoriCampiObbligatoriForm.input_3,
                piva:valoriCampiObbligatoriForm.input_4,
                codfiscale:valoriCampiObbligatoriForm.input_5,
                indirizzo:valoriCampiObbligatoriForm.input_6,
                cap:valoriCampiObbligatoriForm.input_7,
                citta:valoriCampiObbligatoriForm.input_8,
                codiceDestinatario:valoriCampiFacoltativiForm.input_0,
                telefono:valoriCampiFacoltativiForm.input_1,
                giornoChiusuraEsercizio:giornoChiusuraEsercizio,
                meseChiusuraEsercizio:parseInt(meseChiusuraEsercizio)+1,
                pacchettoSelezionato:p
            })
        };

        fetch(Parametri("serverURL"), requestOptions).then(risposta => risposta.json()).then(
            (valoreDiRitorno) => {
                setFlagAttesa(false);
                if (valoreDiRitorno.risultatoOperazione!==1) {
                    alert("Si è verificato un errore gestendo la richiesta, per favore riprova e se l'errore persiste contattaci all'indirizzo "+props.emailAssistenza);
                }
                if(valoreDiRitorno.risultatoOperazione===1){
                    setFlagRegistrato(true);
                }
            },
            (error) => {
                setFlagAttesa(false);
                alert("Si è verificato un errore gestendo la richiesta, per favore riprova e se l'errore persiste contattaci all'indirizzo "+props.emailAssistenza);
            }
        ) 
    }

    // funzione presente in SchedaMioAbbonamento di EMA e Acquista di EMASITO
    function verificaSelezionePacchettoAggiuntivo(p) {
        var ar = pacchettiAggiuntivi.split(';');
        for (var n=0; n<ar.length; n++) if (ar[n] == p) return true;
        return false;
    }

    // funzione presente in SchedaMioAbbonamento di EMA e Acquista di EMASITO
    function aggiungiRimuoviPacchettoAggiuntivo(p) {
        var aggiungi = true;
        var ar = pacchettiAggiuntivi.split(';');
        for (var n=0; n<ar.length; n++) {
            if (ar[n] == p) {
                aggiungi = false;
                break;
            }
        }
        if (aggiungi) {
            var pv = pacchettiAggiuntivi;
            if (pv != "") pv = pv + ";";
            pv = pv + p;            
        } else {
            var pv = "";
            for (var n=0; n<ar.length; n++) {
                if (ar[n] != p) {
                    if (pv != "") pv = pv + ";";
                    pv = pv + ar[n];
                }
            }        
        }
        setPacchettiAggiuntivi(pv);
    }

    // funzione presente in SchedaMioAbbonamento di EMA e Acquista di EMASITO
    function ottieniImportoPacchetto(p) {
        for (var n=0; n<listino.length; n++) {
            if (listino[n].CODICE_ARTICOLO == p) return listino[n].IMPORTO_LORDO;
        }
        return 0;
    }

    // funzione presente in SchedaMioAbbonamento di EMA e Acquista di EMASITO
    function calcolaTotaleImportoPacchettiSelezionati() {
        var ar = pacchettiAggiuntivi.split(';');
        var i = 0;
        if (pacchettoSelezionato!="") i = parseFloat(ottieniImportoPacchetto(pacchettoSelezionato));
        for (var n=0; n<ar.length; n++) i = i + parseFloat(ottieniImportoPacchetto(ar[n]));
        return FormattaImportoVideo(i);
    }    
    
    if (flagAttesa) {
        return (<Clessidra top={window.innerHeight/2} loading={true}/>)
    }

    if (flagRegistrato) {
        return (
            <div className='App'>     
            <MenuAlto {...props} bottoneHome={true}/>
            <Intestazione {...props}/>
            <TitoloPagina {...props}/>

            <div 
                style={{
                    minHeight:props.altezzaContenitoreHome,
                    backgroundColor: "#F5F5F5",
                    marginTop: 20,
                    marginBottom: 40,
                    marginLeft: 20,
                    marginRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    alignItems: "center",
                    display:"flex",
                    flexDirection: "column",
                    cursor:"pointer",
                    fontSize:16,
                    lineHeight:1.4                
                }}
            >
                Grazie per aver effettuato l'ordine.
                <br/><br/>
                Riceverai le indicazioni per il pagamento e l'accesso all'indirizzo email che hai indicato: {valoriCampiObbligatoriForm.input_0}
                <br/><br/>
                <span style={{fontSize:14, fontStyle:"italic"}}>La generazione dell'ordine prevede una verifica manuale dei dati inseriti, pertanto la mail non arriverà immediatamente. Se passa più di un giorno lavorativo senza che tu abbia ricevuto risposta, cortesemente contattaci all'indirizzo {props.emailAssistenza}</span>

                <div 
                    style={{
                        backgroundColor:"#006fe0", 
                        color:'#f0f0f0',                         
                        marginTop:20, 
                        marginBottom:10, 
                        paddingTop:8, 
                        paddingBottom:8, 
                        paddingLeft:20, 
                        paddingRight:20, 
                        cursor:'pointer'
                    }}
                    onClick={() => vaiLink("/")}
                >
                    OK
                </div>

            </div>

            </div>
        )
    }

    return (
        <div className='App'>     
            <MenuAlto {...props} bottoneHome={true}/>
            <Intestazione {...props}/>
            <TitoloPagina {...props}/>

            <div 
                style={{
                    minHeight:props.altezzaContenitoreHome,
                    backgroundColor: "#F5F5F5",
                    marginTop: 20,
                    marginBottom: 40,
                    marginLeft: 20,
                    marginRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    alignItems: "center",
                    display:"flex",
                    flexDirection: "column",
                    cursor:"pointer",
                    fontSize:16,
                    lineHeight:1.4                
                }}
            >
                Compila la form qui sotto per acquistare il prodotto.

                <br/><br/>
                <span style={{fontStyle:'italic', fontSize:14}}>
                    Non daremo i tuoi dati ad altri, li useremo solo per fornirti il servizio o contattarti e li cancelleremo al termine del servizio.<br/>
                    Se hai già accesso alla web app, per acquistare vai alla voce di menu Impostazioni - Mio Abbonamento.
                </span>
                <br/>
                <div style={{                        
                    border:"1px solid #202020", 
                    textAlign:'left', 
                    paddingLeft:10, 
                    width:'90%',
                    backgroundColor:'#FFFFFF', 
                    boxShadow: "1.5px 1.5px #B0B0B0"}}>
                    <span style={{fontSize:13, fontWeight:"bold", color:"#006fe0"}}>Dati necessari</span><br/>
                    <FormResponsive 
                        stile={{border:"1px solid #C0C0C0",fontSize:16,backgroundColor:"#F0F0F0"}}
                        elencoCampi={elencoCampiObbligatori}
                        valoriCampiForm={valoriCampiObbligatoriForm}
                        setValoriCampiForm={setValoriCampiObbligatoriForm}
                    />
                    
                    <div style={{display:"flex",flexDirection:"row", marginTop:10, fontStyle:'italic'}}>
                        Consenso al trattamento dei dati:
                    </div>
                    <div style={{display:"flex",flexDirection:"row", marginTop:5, marginBottom:10}}>
                        <div>
                            <input type='checkbox' checked={flagConsenso || false} onChange={e => { setFlagEvidenziaRichiestaConsenso(false); setFlagConsenso(e.target.checked)}}/>
                        </div>
                        <div style={{width:10}}/>
                        <div style={{flex:1, backgroundColor:flagEvidenziaRichiestaConsenso?"#FFC0C0":""}}>
                            Dichiaro di avere legalmente accesso all'indirizzo email indicato; accetto che tutti i dati inseriti in questa pagina e tutti i dati che inserirò nell'applicazione vengano memorizzati da {props.produttore.ragioneSociale} e mantenuti per tutta la durata della prova del servizio e dell'eventuale successivo acquisto.
                        </div>
                        <div style={{width:10}}/>
                    </div>

                    <div style={{display:"flex",flexDirection:"row", marginTop:10, fontStyle:'italic'}}>
                        Seleziona&nbsp;<b>uno</b>&nbsp;tra i seguenti&nbsp;<b>pacchetti base</b>:
                    </div>                
                    
                    {listino.map((elemento, indice) => elemento.ACQUISTABILE==1 &&                        
                        <div key={indice} style={{display:'flex'}}>                            
                            <label>
                                <input type='checkbox' 
                                    name='pacchettobase' 
                                    value={elemento.CODICE_ARTICOLO} 
                                    checked={pacchettoSelezionato === elemento.CODICE_ARTICOLO}                                         
                                    onChange={e => { setPacchettoSelezionato(e.target.value)}}
                                />
                                <span style={{marginLeft:10, cursor:'pointer'}}>
                                    {elemento.DESCRIZIONE}
                                    , durata: {elemento.ACQUISTABILE==3 ? "fino al termine dell'abbonamento attuale" : elemento.DURATA_VALORE+" "+elemento.DURATA_UNITA_MISURA}
                                    , iscritti: {elemento.LIMITE_ISCRITTI}
                                    , spazio: {elemento.LIMITE_MB} {"MB"}
                                    , importo: {FormattaImportoVideo(elemento.IMPORTO_LORDO)} euro
                                </span>
                            </label>                            
                        </div>                        
                    )}

                    <div style={{display:"flex",flexDirection:"row", marginTop:10, fontStyle:'italic'}}>
                        Seleziona, se vuoi,&nbsp;<b>pacchetti aggiuntivi</b>&nbsp; opzionali tra i seguenti (potrai aggiungerli anche in seguito):
                    </div>                

                    {listino.map((elemento, indice) => elemento.ACQUISTABILE==3 &&                        
                        <div key={indice} style={{display:'flex'}}>                            
                            <label>
                                <input type='checkbox' 
                                    name='pacchettiaggiuntivi' 
                                    value={elemento.CODICE_ARTICOLO} 
                                    checked={verificaSelezionePacchettoAggiuntivo(elemento.CODICE_ARTICOLO)}  
                                    onChange={e => { aggiungiRimuoviPacchettoAggiuntivo(e.target.value)}}
                                />
                                <span style={{marginLeft:10, cursor:'pointer'}}>
                                    {elemento.DESCRIZIONE}
                                    , iscritti: {elemento.LIMITE_ISCRITTI}
                                    , spazio: {elemento.LIMITE_MB} {"MB"}
                                    , importo: {FormattaImportoVideo(elemento.IMPORTO_LORDO)} euro
                                </span>
                            </label>                            
                        </div>                        
                    )}             

                    <br/>

                    <span style={{fontSize:20}}>Importo totale: {calcolaTotaleImportoPacchettiSelezionati()} IVA inclusa.</span>

                </div>
                
                <div style={{                        
                    border:"1px solid #202020", 
                    textAlign:'left',
                    marginTop:20, 
                    paddingLeft:10, 
                    width:'90%',
                    backgroundColor:'#FFFFFF', 
                    boxShadow: "1.5px 1.5px #B0B0B0"}}>
                    
                    <span style={{fontSize:13, fontWeight:"bold", color:"#01a500"}}>
                        Dati facoltativi
                    </span><br/>
                    <FormResponsive 
                        stile={{border:"1px solid #C0C0C0",fontSize:16,backgroundColor:"#F0F0F0"}}
                        elencoCampi={elencoCampiFacoltativi}
                        valoriCampiForm={valoriCampiFacoltativiForm}
                        setValoriCampiForm={setValoriCampiFacoltativiForm}
                    />

                    <div style={{display:"flex",flexDirection:"row", marginTop:10, marginBottom:10, marginRight:15}}>
                        {props.dimensioniApp.flagPaginaOrizzontale ? "Data di chiusura esercizio (normalmente è il 31 dicembre):"
                        : "Chiusura esercizio:" }
                        <div style={{width:10}}/>
                        <div>
                            <select style={{border:"1px solid #C0C0C0", fontSize:16, backgroundColor:"#F0F0F0"}} onChange={e => setGiornoChiusuraEsercizio(e.target.value)}>
                                {giorni.map((giorno,indice)=>
                                    giorno==giornoChiusuraEsercizio ? 
                                        <option key={indice} selected value={giorno}>{giorno}</option>
                                    :
                                        <option key={indice} value={giorno}>{giorno}</option>
                                    )}                                    
                            </select>
                        </div>
                        <div style={{width:10}}/>
                        <div>
                            <select style={{border:"1px solid #C0C0C0", fontSize:16, backgroundColor:"#F0F0F0"}} onChange={e => setMeseChiusuraEsercizio(e.target.value)}>
                                {mesi.map((mese,indice)=>
                                    indice==meseChiusuraEsercizio ?
                                        <option key={indice} selected value={indice}>{mese}</option>
                                    :
                                        <option key={indice} value={indice}>{mese}</option>
                                    )}
                            </select>
                        </div>
                        <div style={{flex:1}}></div>
                    </div>
                </div>

                <div 
                    style={{
                        backgroundColor:"#006fe0", 
                        color:'#f0f0f0',                         
                        marginTop:20, 
                        marginBottom:10, 
                        paddingTop:8, 
                        paddingBottom:8, 
                        paddingLeft:20, 
                        paddingRight:20, 
                        cursor:'pointer'
                    }}
                    onClick={() => inviaDati()}
                >
                    Conferma
                </div>

            </div>
            
            <FondoPagina {...props}/>
        </div>
    )        
}

export default Acquista;